/* unplugin-vue-components disabled */import { render } from "./xradio.vue?vue&type=template&id=c2f0a220"
import script from "./xradio.vue?vue&type=script&lang=js"
export * from "./xradio.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__